const VISITOR_KEY = 'affideaReferralVisitor';
const VISIT_KEY = 'affideaReferralVisit';
const ATTRIBUTION_MS = 24 * 60 * 60 * 1000;
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
let visitorId;
let currentVisit;

const newId = () => {
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
};

export const createReferralVisitRequest = () => {
  try {
    visitorId = window.localStorage.getItem(VISITOR_KEY) || visitorId;
  } catch {
    // In-memory attribution still works when browser storage is blocked.
  }
  if (!GUID.test(visitorId || '')) visitorId = newId();
  try {
    window.localStorage.setItem(VISITOR_KEY, visitorId);
  } catch {}
  return { visitId: newId(), visitorId };
};

export const clearReferralVisit = () => {
  currentVisit = null;
  try {
    window.sessionStorage.removeItem(VISIT_KEY);
  } catch {}
};

export const rememberReferralVisit = (visitId) => {
  if (!GUID.test(visitId || '')) return;
  currentVisit = { visitId, createdAt: Date.now() };
  try {
    window.sessionStorage.setItem(VISIT_KEY, JSON.stringify(currentVisit));
  } catch {}
};

export const readReferralVisitId = () => {
  let visit = currentVisit;
  try {
    const saved = window.sessionStorage.getItem(VISIT_KEY);
    if (saved) visit = JSON.parse(saved);
  } catch {}
  if (!visit || !GUID.test(visit.visitId || '') ||
      !Number.isFinite(visit.createdAt) || visit.createdAt > Date.now() ||
      Date.now() - visit.createdAt >= ATTRIBUTION_MS) {
    clearReferralVisit();
    return null;
  }
  return visit.visitId;
};
